import { EnhancedButtonPrimeReact, EnhancedButtonPrimeReactSeverity, LabelPosition, RHookFormDatePicker } from '@websential/cosmic-v20'
import { Grid, useTheme } from '@mui/material'
import React, { useEffect } from 'react'

import { Link } from 'react-router-dom'
import dayjs from 'dayjs'

interface IInvoiceReportHeader {
    setStateRunGetListAPICall: (value: boolean) => void,
    taxYear: number,
    formMethods: any
}
const InvoiceReportHeader: React.FC<IInvoiceReportHeader> = ({ setStateRunGetListAPICall, taxYear, formMethods }) => {
    const theme = useTheme();
    useEffect(() => {
        // formMethods.setValue('startDate', dayjs(new Date(taxYear, 0, 1)));
        // formMethods.setValue('endDate', dayjs(new Date(taxYear, 11, 31)));
        formMethods.setValue('startDate', new Date(taxYear, 0, 1));
        formMethods.setValue('endDate', new Date(taxYear, 11, 31));
    }, [])
    return (
        <Grid
            container
            size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
            sx={{
                background: "#fff",
                border: "1px solid #e5e7eb",
                borderBottom: 0,
                borderRadius: "2px 2px 0 0",
                padding: "31px 20px 1rem 20px",
                marginBottom: "0!important"
            }}
        >
            <Grid
                size={{ xs: 12, sm: 4, md: 2, lg: 2, xl: 2 }}
            >
                <RHookFormDatePicker
                    name="startDate"
                    testId="start-date"
                    label="Start Date"
                    format="M dd, yy"
                    onDateSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
                />
                <RHookFormDatePicker
                    name="endDate"
                    testId="end-date"
                    label="EndDate"
                    labelPosition={LabelPosition.Top}
                    format="M dd, yy"
                    onDateSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
                />
                <EnhancedButtonPrimeReact
                    label="Apply Filter"
                    raised
                    type="submit"
                    severity={EnhancedButtonPrimeReactSeverity.Secondary}
                />
            </Grid>
            <Grid
                size={{ xs: 12, sm: 2, md: 1, lg: 1, xl: 1 }}
                sx={{ marginTop: "auto", marginLeft: "5px" }}
            ></Grid>
            <Grid size={{ xs: 0, sm: 0, md: 0.5, lg: 0.5, xl: 0.5 }}></Grid>
            <Grid
                size={{ xs: 12, sm: 3, md: 1.5, lg: 1.5, xl: 1.5 }}
                sx={{ color: "rgba(0, 0, 0, 0.6)", fontSize: "0.875rem" }}
            >
                Total Invoice {
                    '0.00'
                }
                <br /> Total Amount
                {
                    '0.00'
                }
            </Grid>
            <Grid
                size={{ xs: 0, sm: 0, md: 4.95, lg: 4.95, xl: 4.95 }}
            ></Grid>
            <Grid
                size={{ xs: 12, sm: 3, md: 2, lg: 2, xl: 2 }}
                sx={{
                    textAlign: "right",
                    color: "rgba(0, 0, 0, 0.6)",
                    fontSize: "0.875rem",
                }}
            >
                <Link
                    to={"/reports/invoice/uncharged-transactions"}
                    className="no-underline"
                    style={{ color: theme.palette.primary.light }}
                >
                    <span
                        style={{
                            color: "#0091b3",
                            fontSize: ".875rem",

                        }}>
                        Uncharged Transactions
                    </span>
                </Link>
                <br />
                SimplePay HST #: <b>88888 8888 RT0001</b><br />
            </Grid>
        </Grid>
    )
}

export default InvoiceReportHeader
